import React, { useCallback, useMemo, useState } from 'react';

import { EuiPopover, EuiText, EuiButtonIcon, EuiFlexItem, EuiProgress, EuiFlexGroup, EuiLoadingSpinner, EuiSpacer, EuiFacetGroup, EuiHealth, EuiNotificationBadge } from '@elastic/eui';
import { ProyectosAdapter } from '../../../infraestructure/persistence/rest/ProyectosAdapter';
import { ServerErrorMessage } from '../../utils/error';
import { useNotifications } from '../../hooks/Notifications';

export const InfoProyectoCellRenderer = (params: any) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [dataInfo, setDataInfo] = useState<any>(undefined)

  const {resultError, exceptionError} = useNotifications();
  const api = new ProyectosAdapter();

  const getInfo = async() =>{
    let result:any;
    try {
      result =  await api.DetalleProyecto(params.value)
      if(result.data && result.data!=="")
			{
        setDataInfo(result.data);
      }else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
      exceptionError(exception)
		}
  }

  const onButtonClick = () =>{
    if(dataInfo===undefined)
    {
      getInfo();
    }
    setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
  }
   
  const closePopover = () => setIsPopoverOpen(false);

  const button = (
    <EuiButtonIcon
        onClick={onButtonClick}
        iconType="iInCircle"
        aria-label="Next"
      />
  );

  const valueMax = useMemo(() => dataInfo && dataInfo.length>0 ? dataInfo[0].OnShore + dataInfo[0].OffShore : 100,[dataInfo]);

  const getOnShore = useMemo(()=>{
    const value = dataInfo && dataInfo.length>0 ? dataInfo[0].OnShore : 0;
    return(
      <EuiProgress
            label={"OnShore"}
            valueText={true}
            value={value}
            max={valueMax}
            color={"secondary"}
            size="m"
          />
    )
  },[dataInfo, valueMax])

  const getOffShore = useMemo(()=>{
    const value = dataInfo && dataInfo.length>0 ? dataInfo[0].OffShore : 0;
    
    return(
      <EuiProgress
            label={"OffShore"}
            valueText={true}
            value={value}
            max={valueMax}
            color={"primary"}
            size="m"
          />
    )
  },[dataInfo, valueMax])

  const esIngenieria = useCallback((sociedad: string)=>{
    return sociedad[0] === '('  ?
      <EuiNotificationBadge className="badgeIngenieria">Ing</EuiNotificationBadge> : null
  },[])

  const getSociedades = useMemo(() =>{
    const soc = (dataInfo && dataInfo.length>0) ? dataInfo[0].Sociedades.split(" + ") : undefined;
    
    if(soc){
      return soc.map((s:string)=>{
      const isIng = esIngenieria(s);
      if(isIng!==null)
      {
        s = s.substring(3)
      }
      const from = s.indexOf("(") +1
      const to = s.indexOf(")")
      const porc = s.substring(from,to);
      const nombre = s.substring(0,from-1).trimRight();

        return (
        <EuiFlexItem>
            <EuiFlexGroup alignItems="center" justifyContent="spaceBetween" className="itemListInfoProyecto">
              <EuiFlexItem>
              <EuiHealth color="success">
              {nombre}
              </EuiHealth>
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <EuiFlexGroup alignItems="center" justifyContent="flexEnd">
                  {isIng !==null ?
                  <EuiFlexItem grow={false}>
                    {isIng}
                  </EuiFlexItem>
                  :null}
                  <EuiFlexItem>
                    <EuiNotificationBadge className="badgePorcentaje">{`${porc}`}</EuiNotificationBadge>
                  </EuiFlexItem>
                </EuiFlexGroup>
              </EuiFlexItem>
            </EuiFlexGroup>
        </EuiFlexItem>
        )
      })
    }
  },[dataInfo,esIngenieria])

  const getNoData = useMemo(()=>{
    return (<EuiFlexGroup alignItems="center" justifyContent="center">
              <EuiFlexItem>
              {(dataInfo===undefined  || dataInfo===null) ? <EuiLoadingSpinner size="xl" className="spinnerPooverCell"/> : "Sin datos"}
              </EuiFlexItem>
            </EuiFlexGroup>)
  },[dataInfo])
 
  return (
    <EuiPopover
      className="popoverCell"
      ownFocus
      button={button}
      isOpen={isPopoverOpen}
      closePopover={closePopover}>
      <EuiText>
      {dataInfo && dataInfo.length >0 ?
      <>
      <EuiFlexGroup direction='column'>
        <EuiFlexItem>
          <EuiFlexGroup>
            <EuiFlexItem>
              {getOnShore}
            </EuiFlexItem>
            <EuiFlexItem>
              {getOffShore}
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiFacetGroup className="popoverCell-list" layout="vertical">
            {getSociedades}
          </EuiFacetGroup>
        </EuiFlexItem>
      </EuiFlexGroup>
      </>
      : getNoData}
      </EuiText>
    </EuiPopover>
  );
};